/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { PropsWithChildren } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { radius, spacing, stroke } from "../../../../../global/emotion";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import { Toggle } from "../../../_base/_core/Toggle/Toggle.emotion";
import { Loader } from "../../other/Loader/Loader.emotion";

const containerStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  borderColor: theme.semanticColors.neutralsLowest,
  borderRadius: radius.m,
  borderStyle: "solid",
  borderWidth: stroke.regular,
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  padding: spacing.ms,
  width: spacing.full,
});
const inputStyle: Interpolation = {
  display: "none",
};
const switchContainerStyle: Interpolation = {
  alignItems: "center",
  columnGap: spacing.ms,
  display: "flex",
  justifyContent: "flex-end",
};

type ToggleInputProps = PropsWithChildren<
  Omit<HallowElementProps<"input">, "onChange"> & {
    onChange: (newValue: boolean) => void;
    labelCSS?: Interpolation;
    loading?: boolean;
  }
>;

export const ToggleInput = ({
  children,
  name,
  id = name,
  checked,
  onChange,
  labelCSS = {},
  loading = false,
  ...props
}: ToggleInputProps) => {
  return (
    <div css={containerStyle}>
      <label htmlFor={name} css={labelCSS}>
        {children}
      </label>
      <div css={switchContainerStyle}>
        {loading && <Loader size={32} />}
        <Toggle
          disabled={props.disabled || loading}
          pressed={checked}
          onPressedChange={onChange}
        />
      </div>
      <input
        type={"checkbox"}
        disabled={loading || props.disabled}
        name={name}
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.currentTarget.checked)}
        css={inputStyle}
        {...props}
      />
    </div>
  );
};
